import {useTranslation} from 'react-i18next';
import {Chip} from './feedback';

export function ExternalProjectBadge({project}:{project:{files_mode?:unknown;folder_kind?:unknown}}){
 const {t}=useTranslation('common');
 return project.files_mode==='external'||project.folder_kind==='attached'?<Chip>{t('projectExternal')}</Chip>:null;
}
export function ProjectDashboardBadge({count,onOpen}:{count:unknown;onOpen:()=>void}){
 const {t}=useTranslation('common');
 if(typeof count!=='number'||!Number.isInteger(count)||count<1)return null;
 return <span className="hylo-chip"><button type="button" aria-label={t('projectDashboardLabel',{count})} onClick={onOpen}>{t('projectDashboardCount',{count})}</button></span>;
}
